import { render, staticRenderFns } from "./prepare-task-add.vue?vue&type=template&id=04eb3dad"
import script from "./prepare-task-add.vue?vue&type=script&lang=js"
export * from "./prepare-task-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports